import {
  IAssessmentsClosingCloseResponse,
  IAssessmentsClosingOpenResponse
} from 'types/assessmentsClosings';
import request from './index';
import toErrorWithMessage from 'utilities/getErrorMessage';

export const closeAssessmentClosing = async (id: number | string) => {
  try {
    return await request<IAssessmentsClosingCloseResponse>({
      options: {
        url: `/assessments_closings/${id}/close`,
        method: 'patch'
      }
    });
  } catch (e) {
    return { data: null, error: toErrorWithMessage(e) };
  }
};

export const openAssessmentClosing = async (id: number | string) => {
  try {
    return await request<IAssessmentsClosingOpenResponse>({
      options: {
        url: `/assessments_closings/${id}/open`,
        method: 'patch'
      }
    });
  } catch (e) {
    return { data: null, error: toErrorWithMessage(e) };
  }
};
